(function (Drupal, $) {
  'use strict';
  Drupal.behaviors.leaveSite = {
    attach: function (context, settings) {
      $('#return-to-main-site').once().on('click', function (e) {
        if (!window.confirm('If you continue you will lose all booking progress made so far, do you wish to continue?')) {
          e.preventDefault();
        }
      });
    }
  };
})(window.Drupal, window.jQuery);
